module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.close(_vm.pix, true)
      }
    }
  }, [_vm._v("\n\t\t\tRecebemos pagamento via PIX do pedido #" + _vm._s(_vm.pix.transaction_id) + ", obrigado! \n\t\t\t"), _c('div', {
    staticClass: "space-10"
  }), _vm._v(" "), _c('strong', {
    staticClass: "font-16"
  }, [_vm._v(" Valor da Recarga: " + _vm._s(_vm._f("money")(_vm.pix.balance)) + " ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    on: {
      "click": function($event) {
        return _vm.close(_vm.pix)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "space-50"
  }), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.pix.date)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fff09f06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/general_notification_components/PixNotification.vue
// module id = 874
// module chunks = 2